export default "__VITE_ASSET__CfLE$iwP__"